import { render, staticRenderFns } from "./CaseShow.vue?vue&type=template&id=61bfcb89&scoped=true"
import script from "./CaseShow.vue?vue&type=script&lang=js"
export * from "./CaseShow.vue?vue&type=script&lang=js"
import style0 from "./CaseShow.vue?vue&type=style&index=0&id=61bfcb89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bfcb89",
  null
  
)

export default component.exports